import { isNil } from 'lodash'
import i18nCountries, { Alpha3Code } from 'i18n-iso-countries'
import countriesFrLang from 'i18n-iso-countries/langs/fr.json'
import countriesEnLang from 'i18n-iso-countries/langs/en.json'

import { Currency } from '../models/moneyModel'
import { CountryCode } from '../models/debtorModels'

i18nCountries.registerLocale(countriesEnLang)
i18nCountries.registerLocale(countriesFrLang)

export type LocalizeAmountsOptions = {
    currencyDisplay?: Intl.NumberFormatOptionsCurrencyDisplay
    locale?: string
}

export const localizeAmounts = (
    amount: number | string | undefined | null,
    currency: Currency | null | undefined,
    { currencyDisplay = 'symbol', locale = 'en' }: LocalizeAmountsOptions
): string => {
    return !isNil(amount) && !isNil(currency)
        ? (typeof amount === 'string' ? Number(amount) : amount).toLocaleString(locale, {
              style: 'currency',
              currency,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
              currencyDisplay
          })
        : '-'
}

export type LocalizeMonthProps = {
    month: number
    locale?: string
}

export const localizeMonth = ({ month, locale = 'en' }: LocalizeMonthProps): string | null => {
    const format = new Intl.DateTimeFormat(locale, { month: 'long' }).format
    if (month >= 0 && month <= 11) {
        const result = format(new Date(Date.UTC(2021, month % 12)))
        return result.charAt(0).toUpperCase() + result.slice(1)
    }
    return null
}

export type LocalizeCountryProps = {
    countryCode: undefined | string | number | CountryCode | Alpha3Code
    locale: string
}

export const localizeCountry = ({ countryCode, locale }: LocalizeCountryProps): string | undefined => {
    return i18nCountries.getName(countryCode ?? '', locale ?? '')
}
